import i18n from '@/locale';
import store from '@/redux/store';
import types from '@/redux/type';
import { getStorage, setStorage } from './storage';

// 获取 对应账号的语言
export const getLocalLangs = (account: string) => {
	let langs = getStorage('centerServerLangs') || {};
	if (langs[account]) {
		i18n.changeLanguage(langs[account].toLowerCase());
		setStorage('lang', langs[account], 'locale');
	}
};
// 更新 语言列表
export const setLocalLangs = (account: string, lang: string) => {
	let langs = getStorage('centerServerLangs') || {};
	if (langs[account]) {
		langs[account] = lang;
	} else {
		langs[account] = lang;
	}
	store.dispatch({
		type: types.CHANGE_USER_LANG,
		data: lang,
	});
	setStorage('centerServerLangs', langs, 'locale');
	i18n.changeLanguage(lang.toLowerCase());
	setStorage('lang', lang, 'locale');
};
